<template>
  <div v-if="currentObjectif">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-responsive bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Nom de l'objectif </span>
                  </td>
                  <td>
                    {{ currentObjectif.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold">
                      Date de réalisation prévisionnelle
                    </span>
                  </td>
                  <td>
                    {{ currentObjectif.date_realisation_prevu }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentObjectif.document.created_by.prenom
                        ? currentObjectif.document.created_by.prenom +
                          ' ' +
                          currentObjectif.document.created_by.nom
                        : currentObjectif.document.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date d'attribution </span>
                  </td>
                  <td>
                    {{ currentObjectif.date_attribution }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date de réalisation </span>
                  </td>
                  <td>
                    {{
                      currentObjectif.date_realisation
                        ? currentObjectif.date_realisation
                        : '###'
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Statut</span>
                  </td>
                  <td>
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="getClassOfEO(currentObjectif.statut)"
                    ></i>
                    {{ getStatutEO(currentObjectif.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row" v-if="currentObjectif.statut === CONST.OBJ_ATTEINT">
        <div class="col-md-12 col-lg-6">
          <b-card class="text-black" header-class="bg-silver">
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="far fa-comments"></i> Commentaire
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <p
                  v-html="currentObjectif.commentaire"
                  v-if="currentObjectif.commentaire"
                ></p>
                <p v-else>Pas de commentaire</p>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CONST from '@/constants/rh/employe';
export default {
  data() {
    return {
      CONST,
    };
  },
  computed: {
    ...mapGetters('employe', ['currentObjectif']),
  },
};
</script>

<style scoped></style>
